module.exports = __webpack_public_path__ + "static/media/003_northstar_workshop.33a9e9e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/003_northstar_workshop.png
// module id = 636
// module chunks = 0